/**
 * @file 路由配置
 * @date 2021-06-24
 */

export default [
    {
        path: '/',
        redirect: '/trade/spot/',
    },
    {
        path: '/trade/spot/launchpad/',
        component: () => import('@/views/launchpad/index'),
        meta: {
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/launchpad-list/',
        component: () => import('@/views/launchpad/list'),
        meta: {
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/launchpad-order/',
        component: () => import('@/views/launchpad/center'),
        meta: {
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
            needLogin: true,
        },
    },
    {
        path: '/trade/spot/launchdetail/',
        component: () => import('@/views/launchpad/detail'),
        meta: {
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/launchdetail/old/',
        component: () => import('@/views/launchpad/detailOld'),
        meta: {
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/launchpad-assets/',
        component: () => import('@/views/launchpad/assets'),
        meta: {
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/m/launchpad/',
        component: () => import('@/views/mobile/launchpad/index'),
        meta: {
            layout: 'Mobile',
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/m/launchpad/list/',
        alias: '/trade/spot/m/launchpad-list/',
        component: () => import('@/views/mobile/launchpad/list'),
        meta: {
            layout: 'Mobile',
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/m/launchpad/detail/',
        alias: '/trade/spot/m/launchdetail/',
        component: () => import('@/views/mobile/launchpad/detail'),
        meta: {
            layout: 'Mobile',
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/m/launchpad/detail/old/',
        alias: '/trade/spot/m/launchdetail/old/',
        component: () => import('@/views/mobile/launchpad/detailOld'),
        meta: {
            layout: 'Mobile',
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/m/launchpad/assets/',
        alias: '/trade/spot/m/launchpad-assets/',
        component: () => import('@/views/mobile/launchpad/assets'),
        meta: {
            layout: 'Mobile',
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
        },
    },
    {
        path: '/trade/spot/m/launchpad/orders/',
        alias: '/trade/spot/m/launchpad-order/',
        component: () => import('@/views/mobile/launchpad/center'),
        meta: {
            layout: 'Mobile',
            title: 'lp_tdk_title',
            ogtitle: 'lp_tdk_title',
            ogdescription: 'lp_tdk_desc',
            needLogin: true,
        },
    },

    process.env.NODE_ENV !== 'production'
        ? {
            path: '/login/',
            component: () => import('@/views/login'),
        }
        : {},
    {
        path: '/:nofound*',
        component: () => import('@/views/404'),
        meta: {
            layout: 'Mobile',
            title: 'title_404',
        },
    },
];
